(() => {
  for (const host of document.querySelectorAll('carzilla-help')) {
    if (host.shadowRoot) continue;
    const root = host.attachShadow({mode:'open'});
    root.innerHTML = `<style>:host{position:fixed;right:16px;bottom:calc(16px + env(safe-area-inset-bottom));z-index:2147480000;font:14px Arial,sans-serif;color:#272831}button{font:inherit;min-height:48px;border:0;border-radius:24px;background:#00bfc0;color:#fff;padding:10px 16px;box-shadow:0 4px 18px #12363824;cursor:pointer}.launcher{display:block;margin-left:auto;min-width:160px;min-height:60px;padding:14px 22px;border-radius:30px;font-size:15px;color:#fff}button:focus-visible{outline:3px solid #006a6b;outline-offset:3px}.error{background:white;color:#272831;padding:12px;border-radius:10px;max-width:280px}a{color:#006a6b}@media(max-width:768px){:host([data-mobile-nav]){right:12px;bottom:calc(var(--cz-help-nav-height,calc(45px + env(safe-area-inset-bottom))) + 8px)}:host([data-mobile-nav])>.launcher{display:none!important}}</style><button class="launcher" type="button" aria-expanded="false" aria-haspopup="dialog"></button>`;
    const button=root.querySelector('button');
    button.textContent=host.dataset.label||'Rewards & Help';
    let loading=false,navButton=null,navObserver=null,expanded=false;
    const mobile=()=>window.matchMedia('(max-width:768px)').matches;
    host.helpReturnFocus=()=>mobile()&&navButton?.isConnected&&!navButton.hidden?navButton:button;
    host.syncHelpState=open=>{
      expanded=open;button.setAttribute('aria-expanded',String(open));
      navButton?.setAttribute('aria-expanded',String(open));
    };
    function connectNav(){
      const next=document.querySelector('.cz-mobile-bottom-nav [data-carzilla-help-toggle]');
      if(next===navButton)return;
      navObserver?.disconnect();navButton=next;
      host.toggleAttribute('data-mobile-nav',!!next);
      if(!next)return;
      next.hidden=false;next.setAttribute('aria-label',button.textContent);next.setAttribute('aria-expanded',String(expanded));
      const nav=next.closest('.cz-mobile-bottom-nav');
      const measure=()=>{const height=nav.getBoundingClientRect().height;if(height>0)host.style.setProperty('--cz-help-nav-height',height+'px');};
      if(typeof ResizeObserver==='function'){navObserver=new ResizeObserver(measure);navObserver.observe(nav);}
      measure();
    }
    function closeRewards(){
      const panel=document.querySelector('.smile-launcher-frame-container.smile-launcher-open, .smile-panel-frame-container:not(.smile-panel-exit):not(.smile-panel-exit-active):not(.smile-panel-exit-done)');
      if(!panel||typeof window.SmileUI?.closePanel!=='function')return false;
      window.SmileUI.closePanel();
      host.syncHelpState(false);
      return true;
    }
    // Close rewards before the toolbar opens another destination.
    document.addEventListener('click',event=>{
      if(mobile()&&event.target.closest?.('.cz-mobile-bottom-nav [data-cz-action]'))closeRewards();
    },true);
    async function activate(){
      if(loading)return;
      if(closeRewards()){host.helpReturnFocus().focus();return;}
      if(host.openHelp)return host.openHelp();
      loading=true;button.disabled=true;button.setAttribute('aria-busy','true');navButton?.setAttribute('aria-busy','true');
      try{
        const module=await import(host.dataset.module);
        await module.mount(host,root,button);
        root.querySelector('.error')?.remove();host.openHelp();host.setAttribute('data-launcher-ready','');
      }catch{
        host.removeAttribute('data-launcher-ready');
        if(!root.querySelector('.error')){const p=document.createElement('p');p.className='error';p.textContent='Unable to open help. ';const a=document.createElement('a');a.href=host.dataset.contact||'/pages/contact';a.textContent='Contact CARZILLA';p.append(a);root.append(p);}
      }finally{loading=false;button.disabled=false;button.removeAttribute('aria-busy');navButton?.removeAttribute('aria-busy');}
    }
    button.addEventListener('click',activate);
    document.addEventListener('click',event=>{
      const trigger=event.target.closest?.('[data-carzilla-help-toggle]');
      if(!trigger||trigger!==navButton)return;
      event.preventDefault();void activate();
    });
    connectNav();
    document.addEventListener('DOMContentLoaded',connectNav,{once:true});
    document.addEventListener('shopify:section:load',connectNav);window.addEventListener('pageshow',connectNav);
    host.setAttribute('data-launcher-ready','');
    if(['chat','tracking','change_address','edit_items','cancel','rush','missing_rewards','price_match','returns','callback'].includes(new URL(location.href).searchParams.get('cz_help')))button.click();
  }
})();
